import { render, staticRenderFns } from "./Planet.vue?vue&type=template&id=683a532c&scoped=true&"
import script from "./Planet.vue?vue&type=script&lang=js&"
export * from "./Planet.vue?vue&type=script&lang=js&"
import style0 from "./Planet.vue?vue&type=style&index=0&id=683a532c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a532c",
  null
  
)

export default component.exports